export default __webpack_public_path__ + "static/media/BMW_Grey.7f7e30cd.svg";